import _, { isObject } from 'lodash';
import { any } from './array';

export const compareDeep = (object, baseObject) => {
  if (Array.isArray(object)) {
    if (object.length !== baseObject.length) {
      return object;
    }

    const diff = _.difference(object, baseObject);
    return diff.length === 0 ? baseObject : object;
  }

  if (typeof object === 'object') {
    return _.transform(object, (result, value, key) => {
      if (!_.isEqual(value, baseObject[key])) {
        // eslint-disable-next-line no-param-reassign
        result[key] = _.isObject(value) && _.isObject(baseObject[key]) ? compareDeep(value, baseObject[key]) : value;
      }
    });
  }
};

export const flattenObj = obj => {
  if (!obj || typeof obj !== 'object' || obj === null) {
    throw Error(`flattenObj function expects an Object, received ${typeof obj}`);
  }
  return Object.keys(obj).reduce((acc, curr) => {
    const objValue = obj[curr];
    const ret = objValue && objValue instanceof Object ? flattenObj(objValue) : { [curr]: objValue };
    return Object.assign(acc, ret);
  }, {});
};

const filterFalsy = obj =>
  Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => {
      if (isObject(value)) {
        filterFalsy(value);
        return;
      }

      return value;
    })
  );

export const serializeQuerystring = obj => {
  const filtered = filterFalsy(obj);
  const params = new URLSearchParams(filtered).toString();

  return params !== '' ? `&${params}` : '';
};

const parameterizeArray = (key, arr) => {
  if (!any(arr)) {
    return;
  }

  return `&${key}=${arr.join(`&${key}=`)}`;
};

const getKeysFromTruthyValuesOnly = values =>
  Object.entries(values).reduce((acc, [key, value]) => {
    if (value) {
      acc = [...acc, key];
    }

    return acc;
  }, []);

export const serializeQueryStringWithMultipleValuesSelected = obj => {
  const queryWithMultipleValuesSelected = Object.entries(obj)
    .map(([key, values]) => {
      const truthyKeys = getKeysFromTruthyValuesOnly(values);

      return parameterizeArray(key, truthyKeys);
    })
    .filter(Boolean);

  const params = queryWithMultipleValuesSelected.join('');

  return params;
};

export default compareDeep;
